// IdleHint — fires suggestion callback setelah idleMs tanpa user activity.
// Reset timer setiap pointerdown/keydown/touchstart. Random pick dari suggestions
// (no immediate repeat).

const DEFAULT_IDLE_MS = 30000
const DEFAULT_EVENTS = ['pointerdown', 'keydown', 'touchstart']

export function createIdleHint({
  idleMs = DEFAULT_IDLE_MS,
  onSuggest,
  suggestions = [],
  activityEvents = DEFAULT_EVENTS,
  document: doc = typeof document !== 'undefined' ? document : null,
} = {}) {
  if (typeof onSuggest !== 'function') throw new Error('IdleHint: onSuggest is required')

  let timer = null
  let lastIndex = -1
  let running = false
  const handlers = []

  function pickRandom() {
    if (suggestions.length === 0) return null
    if (suggestions.length === 1) return suggestions[0]
    let idx
    do {
      idx = Math.floor(Math.random() * suggestions.length)
    } while (idx === lastIndex)
    lastIndex = idx
    return suggestions[idx]
  }

  function fire() {
    const pick = pickRandom()
    if (pick) onSuggest(pick)
    schedule()
  }

  function schedule() {
    if (!running) return
    if (timer !== null) clearTimeout(timer)
    timer = setTimeout(fire, idleMs)
  }

  function reset() {
    schedule()
  }

  function onActivity() {
    if (running) reset()
  }

  function start() {
    if (running || !doc) return
    running = true
    activityEvents.forEach((evt) => {
      const h = onActivity
      doc.addEventListener(evt, h, { passive: true })
      handlers.push({ evt, h })
    })
    schedule()
  }

  function stop() {
    if (!running) return
    running = false
    if (timer !== null) {
      clearTimeout(timer)
      timer = null
    }
    handlers.forEach(({ evt, h }) => doc.removeEventListener(evt, h))
    handlers.length = 0
  }

  function isRunning() {
    return running
  }

  return { start, stop, reset, isRunning }
}
